import React from 'react';

const PALETTE = ['#008385','#1a7f4b','#6b45c8','#b45309','#c0392b','#00b3b5','#374151','#9ca3af'];

/**
 * Pure-CSS conic-gradient donut — avoids Recharts SVG rendering issues inside
 * flex/overflow containers. Renders a donut chart using CSS conic-gradient.
 */
const DonutChart = ({ items }) => {
  const total = items.reduce((s, item) => s + item.count, 0);
  if (!total) return null;

  // Build conic-gradient stops
  let angle = 0;
  const stops = items.map((item, i) => {
    const share = (item.count / total) * 360;
    const color = PALETTE[i % PALETTE.length];
    const from = angle;
    const to   = angle + share;
    angle = to;
    return `${color} ${from.toFixed(1)}deg ${to.toFixed(1)}deg`;
  });

  const gradient = `conic-gradient(${stops.join(', ')})`;

  return (
    <div style={{ position: 'relative', width: 96, height: 96, flexShrink: 0 }}>
      {/* Outer ring */}
      <div style={{
        width: 96,
        height: 96,
        borderRadius: '50%',
        background: gradient,
      }} />
      {/* Inner cutout (donut hole) */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 54,
        height: 54,
        borderRadius: '50%',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: '#6b7280' }}>{items.length}</span>
      </div>
    </div>
  );
};

const DeviceBrowserSection = ({ title, data }) => {
  if (!data?.length) return null;
  // Normalise: API may return count/pct as strings → cast to numbers
  const items = data.map(item => ({
    ...item,
    // Live API may only return pct; fall back to pct when count is missing/zero
    count: +(item.count) || +(item.sessions) || +(item.total) || +(item.pct) || 0,
    pct:   +(item.pct)   || 0,
  }));

  return (
    <div className="ar-card">
      <div className="ar-card-header">{title} Breakdown</div>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
        <DonutChart items={items} />
        {/* Legend */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {items.slice(0, 6).map((item, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: PALETTE[i % PALETTE.length], flexShrink: 0, marginRight: 7 }} />
                <span style={{ fontSize: 12, color: '#374151', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {item.name}
                </span>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#111827', marginLeft: 8 }}>
                  {item.pct}%
                </span>
              </div>
              <div className="ar-progress-track" style={{ height: 4 }}>
                <div
                  className="ar-progress-fill"
                  style={{ width: `${item.pct}%`, background: PALETTE[i % PALETTE.length] }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeviceBrowserSection;
export { DeviceBrowserSection };
